import React from 'react';
import { FormDatePickerProps } from './form-types';
import { DatePicker, Dayjs } from '@carrotfertility/carotene-core';
import { Controller, useFormContext } from 'react-hook-form';
import { getFormInputState } from './form-utils';

export function FormDatePicker({
    name,
    error,
    controllerProps,
    helperText,
    label,
    ...otherProps
}: FormDatePickerProps<Dayjs>) {
    const {
        control,
        formState: { errors, isSubmitting },
    } = useFormContext();

    const { error: hasError, helperText: helperTextValue } = getFormInputState({
        name,
        errors,
        error,
        helperText,
    });

    return (
        <Controller
            {...(controllerProps || {})}
            {...{ control, name }}
            render={({ field }) => (
                <DatePicker
                    {...otherProps}
                    {...field}
                    disabled={isSubmitting || otherProps.disabled}
                    slotProps={{
                        textField: {
                            name,
                            error: hasError,
                            helperText: helperTextValue,
                            required: otherProps.required
                                ? otherProps.required
                                : Boolean(controllerProps?.rules?.required),
                        },
                    }}
                    label={label}
                />
            )}
        />
    );
}
